import { ReactElement } from 'react'
import illustration from '../images/Padasjoki3.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Ihan hyvin, tänään oli hyviä leikkejä.',
    gotoStage: 4
  },
  {
    text: 'Tänään oli tosi hauska päivä jekuttaa bussikuskia taas kerran, eikä jääty kiinni!',
    gotoStage: 0
  },
  {
    text: 'Yksi mun kaveri tänään teki tosi ilkeän tempun bussikuskille, olin tosi järkyttynyt siitä...',
    gotoStage: 0
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const PadasjokiStage3 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle small>Jekku bussikuskille</StageTitle>
      <StageText>
        ”Äkkiä nyt, kohta se bussi tulee!” huudat, sillä kuulet jo kaukaista bussin hurinaa. Juosten piiloudutte pusikkoon ystäviesi kanssa. Näky oli kuin hidastetusta filmistä, kun bussin vauhti pysähtyi ennen patoa, ovi aukesi ja kuski tuli kiroten ulos: ”Ei taas näitä kakaroita, missä olette? Odottakaahan kun saan teidät kiinni ja kerron vanhemmillenne puuhistanne!” Kuskin vauhkotessa bussissa olleet matkustajat tulivat valitellen ulos.
      </StageText>
      <StageText>
        Sekalainen puheensorina täytti ilman, kun he yhteistuumin potkivat padon rikki. ”Eikä, taas täytyy työntää...” naisääni sanoi. Tunnet, kuinka nauru kutkuttaa vatsanpohjaa ja nostat kädet suusi eteen, ettei hihittely kuuluisi. Ystäväsi kiemurtelevat myös hykerrellen. Matkustajat siirtyivät tehottoman häkäpönttö linja-auton taakse ja valmistautuivat työntämään sen mäkeä ylös. Pillin vislaus kuului taas. Tämän täytyi olla päivän viimeinen vislaus, koska yksi oli kuulunut, kun rakensitte patoa. ”Työpäivä päättyi, täytyy lähteä takaisin”, huikkaat kavereillesi ja ponkaiset juoksuun.
      </StageText>
      <StageText>
        Palattuasi löydät isäsi keskustelemasta proomumestarin kanssa. ”Ihan käsityötähän se proomun rakentaminen on ja vie kokonaisen talven saada valmiiksi. Joka ikinen lankku on muotoiltu kirveellä ja höylällä”, pohtii proomumestari. Tökkäät kesken keskustelun isäsi kylkeä. ”Mennäänkö?” kuiskaat ujosti. Isäsi naurahtaa. Hän hyvästelee proomumestarin ja lähdette yhdessä kävelemään kotia kohti. ”Mites sinun päiväsi meni? Ja miten vaatteesi voivat olla taas noin likaiset...?” isä ihmettelee.
      </StageText>
      <StageText>
        <strong>Mitä vastaat?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default PadasjokiStage3
